var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23515 0.277138C1.41283 0.0996771 1.65368 0 1.90481 0C2.15593 0 2.39678 0.0996771 2.57447 0.277138L6.01121 3.71388L9.44796 0.277138C9.62759 0.109748 9.86519 0.01862 10.1107 0.0229516C10.3562 0.0272832 10.5904 0.126736 10.7641 0.300359C10.9377 0.473981 11.0371 0.708217 11.0415 0.953719C11.0458 1.19922 10.9547 1.43682 10.7873 1.61646L6.68087 5.72286C6.50319 5.90032 6.26233 6 6.01121 6C5.76009 6 5.51923 5.90032 5.34155 5.72286L1.23515 1.61646C1.05769 1.43878 0.958008 1.19792 0.958008 0.946798C0.958008 0.695674 1.05769 0.454819 1.23515 0.277138Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.6d049cf7d2ec70d8fab5f92d6247d50a.svg";
export { ForwardRef as ReactComponent };